import { ForwardPriceCurveContent } from './forward-price-curve-content';

export function ForwardPriceCurvePage() {
  return <ForwardPriceCurveContent />;
}
